import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export function useProductCategory() {
  const api = useApi() 
  const [dataCategory, setData] = useState<SelectOptionType[]>([])
  const [isLoadingCategory, setLoading] = useState(true)

  const refetchCategory = () => {
    setLoading(true)

    api.get("/productcategory/")
    .then((res: SuccessFetch<{
      payload: {
        mr_product_category_id: number
        mr_product_category_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.mr_product_category_name, value: item.mr_product_category_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    api.get("/productcategory/")
    .then((res: SuccessFetch<{
      payload: {
        mr_product_category_id: number
        mr_product_category_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.mr_product_category_name, value: item.mr_product_category_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { dataCategory, isLoadingCategory, refetchCategory }
}